import NgConfig from "../NgConfig"

// Events
// fileSelected
// fileDeleted
// fileListUpdated



type MyFilesListOptions = {
  csrfToken: string
  toolId: number
}

class MyFilesList {
  content: string | null
  csrfToken: string
  fetchCron?: number
  options: MyFilesListOptions
  toolId: number

  constructor(options: MyFilesListOptions) {
    this.content = null
    this.csrfToken = options.csrfToken
    this.fetchCron = setInterval(this.fetchContent.bind(this), 60000);
    this.toolId = options.toolId
    this.options = options
  }

  on(eventName: string, callback: (event: Event) => void) {
    document.addEventListener(eventName, callback)
  }

  off(eventName: string, callback: (event: Event) => void) {
    document.removeEventListener(eventName, callback)
  }

  off_all_events() {
    document.removeEventListener('fileSelected', () => { })
    document.removeEventListener('fileDeleted', () => { })
    document.removeEventListener('fileListUpdated', () => { })
  }

  _dispatchEvent(eventName: string, detail: any) {
    document.dispatchEvent(new CustomEvent(eventName, { detail }))
  }

  async handleDeleteBulk(shortIds: string[]) {
    await this.deleteBulk(shortIds)
  }

  handleDeleteOne(shortId: string) {
    this.deleteOne(shortId)
  }

  handleSelectOne(shortId: string) {
    this._dispatchEvent('fileSelected', { shortIds: [shortId] })
  }

  handleDownloadOne(url: string, name: string) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobURL;
        if (name && name.length) a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        eventRecorder.captureEvent('file_downloaded');
      })
      .catch((e) => alert("Download failed: " + e.message));
  }

  async fetchContent() {
    this.content = null
    let response: Response | null = null

    try {
      response = await fetch(`${NgConfig.FILES_URL}/tool/${this.toolId}/`, {
        method: 'GET',
        headers: {
          accept: 'application/html'
        },
      })
    } catch (e) {
      console.error(e)
      this.content = 'Error fetching file list'
    }

    if (response && !response.ok) {
      console.error(response.statusText)
      this.content = 'Error fetching file list'
    }

    if (response && response.ok) {
      this.content = await response.text()
    }

    // if (!response.ok)
    //   throw new Error(`Unsuccessful request: ${response.statusText}`)
    // this.content = await response.text()
    const listContent = document.getElementById('file-list-content')
    if (listContent) {
      listContent.innerHTML = this.content || ''
      listContent.focus()
    }
    this._dispatchEvent('fileListUpdated', {})
  }

  getContent() {
    return this.content
  }

  async deleteBulk(shortIds: string[]) {
    const deleted: string[] = []
    shortIds.forEach(async (shortId) => {
      try {
        await this.deleteOne(shortId)
        deleted.push(shortId)
      } catch (e) {
        console.error(e)
      }
    })
    eventRecorder.captureEvent('files_deleted', { deleted: deleted, gotAll: shortIds.length === deleted.length })
    await this.fetchContent()
  }

  async deleteOne(shortId: string) {
    const response = await fetch(`${NgConfig.FILES_API_URL}/${shortId}/`, {
      method: 'DELETE',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    })
    if (!response.ok)
      throw new Error(`Unsuccessful request: ${response.statusText}`)
    eventRecorder.captureEvent('file_deleted');
    this.fetchContent()
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {

      this.on('fileListUpdated', (e) => {
        this.off_all_events();

        document.getElementById('delete-button')?.addEventListener('click', () => {
          const shortIds = Array.from(document.querySelectorAll('button.trashit')).map((button: Element) => button.dataset.shortid)
          this.handleDeleteBulk(shortIds)
        });
        const deleteOneButtons = document.querySelectorAll('button.trashit');
        deleteOneButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            this.handleDeleteOne(e.currentTarget?.dataset.shortid);
          });
        });
        const downloadButtons = document.querySelectorAll('button.downloadit');
        downloadButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            if (e.currentTarget && e.currentTarget instanceof HTMLElement && e.currentTarget.dataset.url &&
              e.currentTarget.dataset.name) {
              this.handleDownloadOne(e.currentTarget.dataset.url, e.currentTarget.dataset.name);
            }
          });
        });
        const selectButtons = document.querySelectorAll('a.selectit');
        selectButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault()
            this.handleSelectOne(e.currentTarget?.dataset.shortid);
          });
        });
      })

    });
  }
}

export default MyFilesList

// Params are loaded by a previous inline script
// @ts-ignore
const myFilesList = new MyFilesList({ csrfToken: csrf, toolId: tool_id })

myFilesList.init()
myFilesList.on('fileSelected', (e: Event) => {
  const shortIds = (e as CustomEvent).detail.shortIds
  //console.log('fileSelectedfdfsdf', shortIds)
  eventRecorder.captureEvent('file_selected', { ids: shortIds })
  // @ts-ignore
  window.location.replace(`/tools/${refname}/params` + "?short_ids=" + shortIds.join(","))
})
myFilesList.fetchContent()